'use strict';

var _require = require('./baseProperties'),
    baseProperties = _require.baseProperties;

module.exports.AbstractPersonSchema = {
  title: 'AbstractPerson',
  type: 'object',
  properties: Object.assign({}, baseProperties)
};


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/schema/abstractPerson.js
// module id = UjEd
// module chunks = 0